import { FileHandle } from "kreate-common/modules/business-types";

export function getAspectRatioFromFile(file: FileHandle | null | undefined) {
  if (!file) return undefined;
  const { width, height } = file.blob;
  return width && height ? width / height : undefined;
}
